// extracted by mini-css-extract-plugin
module.exports = {"list":"index-module--list--1y_dM","active":"index-module--active--26znL"};